import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-379">
      <div className="max-w-5xl mx-auto" data-id="element-380">
        <div className="max-w-2xl mx-auto mb-12" data-id="element-381">
          <div className="bg-black border border-[#A855F7]/30 rounded-2xl p-6" data-id="element-382">
            <h3 className="text-[#A855F7] text-xl font-black mb-5" data-id="element-383">
              💪 6 TOMOS COMPLETOS
            </h3>
            <div className="space-y-4" data-id="element-384">
              <div className="flex items-center gap-3 text-white" data-id="element-385">
                <span className="text-xl" data-id="element-386">📘</span>
                <div className="flex-1" data-id="element-387">
                  <span className="font-bold" data-id="element-388">Tomo 1 — REFORMER EXPLOSIVO</span>
                  <span className="text-gray-300" data-id="element-389">
                    {' '}
                    24 clases de Reformer. Inicial, Intermedio y Avanzado.
                    Resorte, series, repeticiones y cues listos.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-390">
                <span className="text-xl" data-id="element-391">📗</span>
                <div className="flex-1" data-id="element-392">
                  <span className="font-bold" data-id="element-393">
                    Tomo 2 — MAT PILATES & PROPS
                  </span>
                  <span className="text-gray-300" data-id="element-394">
                    {' '}
                    32 clases con Mat, Pelota, Aro y Bandas. Ideal para grupos
                    grandes o estudios sin Reformer.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-395">
                <span className="text-xl" data-id="element-396">📙</span>
                <div className="flex-1" data-id="element-397">
                  <span className="font-bold" data-id="element-398">Tomo 3 — PILATES CLÍNICO</span>
                  <span className="text-gray-300" data-id="element-399">
                    {' '}
                    11 protocolos para hernias, escoliosis, hipercifosis,
                    rodilla y cadera. Trabajá con confianza.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-400">
                <span className="text-xl" data-id="element-401">📕</span>
                <div className="flex-1" data-id="element-402">
                  <span className="font-bold" data-id="element-403">
                    Tomo 4 — POBLACIONES ESPECIALES
                  </span>
                  <span className="text-gray-300" data-id="element-404">
                    {' '}
                    24 clases para embarazo, posparto, adultos mayores y
                    osteoporosis. Adaptadas por trimestre.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-405">
                <span className="text-xl" data-id="element-406">📓</span>
                <div className="flex-1" data-id="element-407">
                  <span className="font-bold" data-id="element-408">
                    Tomo 5 — FLOW & TRANSICIONES
                  </span>
                  <span className="text-gray-300" data-id="element-409">
                    {' '}
                    100 transiciones + 24 clases flow de 30, 45 y 60 min. Clases
                    que se sienten como experiencias.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-410">
                <span className="text-xl" data-id="element-411">📔</span>
                <div className="flex-1" data-id="element-412">
                  <span className="font-bold" data-id="element-413">
                    Tomo 6 — PLANILLA DE NEGOCIO
                  </span>
                  <span className="text-gray-300" data-id="element-414">
                    {' '}
                    Cobros, agenda, métricas, WhatsApp, redes y pricing.
                    Convertí tu talento en negocio rentable.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#A855F7]/5 border border-[#A855F7]/30 rounded-2xl p-8 text-center" data-id="element-415">
          <h3 className="text-[#A855F7] text-xl font-black mb-6" data-id="element-416">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-417">
            <div className="flex items-start gap-2 text-left" data-id="element-418">
              <span className="text-[#A855F7] font-bold flex-shrink-0" data-id="element-419">✅</span>
              <span className="text-white text-sm" data-id="element-420">
                Clases 100% listas — abrís el PDF y arrancás
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-421">
              <span className="text-[#A855F7] font-bold flex-shrink-0" data-id="element-422">✅</span>
              <span className="text-white text-sm" data-id="element-423">
                3 niveles: Inicial / Intermedio / Avanzado
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-424">
              <span className="text-[#A855F7] font-bold flex-shrink-0" data-id="element-425">✅</span>
              <span className="text-white text-sm" data-id="element-426">
                Cues verbales, resortes, series y repeticiones
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-427">
              <span className="text-[#A855F7] font-bold flex-shrink-0" data-id="element-428">✅</span>
              <span className="text-white text-sm" data-id="element-429">
                Fichas de seguimiento y progresión del alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-430">
              <span className="text-[#A855F7] font-bold flex-shrink-0" data-id="element-431">✅</span>
              <span className="text-white text-sm" data-id="element-432">
                Diseñado para el instructor argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}